import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
} from "@angular/core";
import { FormBuilder, ReactiveFormsModule, Validators } from "@angular/forms";
import { Router, RouterLink } from "@angular/router";
import { fadeInUp400ms } from "@vex/animations/fade-in-up.animation";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatIconModule } from "@angular/material/icon";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatButtonModule } from "@angular/material/button";
import { NgIf } from "@angular/common";
import { MatInputModule } from "@angular/material/input";
import { MatFormFieldModule } from "@angular/material/form-field";
import { AuthService } from "src/app/services/auth.service";
import { UserService } from "src/app/services/user.service";
import { User, UserCredential } from "@angular/fire/auth";
import { SnackbarService } from "src/app/services/snackbar.service";

@Component({
  selector: "vex-login",
  templateUrl: "./sign-in.component.html",
  styleUrls: ["./sign-in.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [fadeInUp400ms],
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    NgIf,
    MatButtonModule,
    MatTooltipModule,
    MatIconModule,
    MatCheckboxModule,
    RouterLink,
  ],
})
export class SignInComponent {
  form = this.fb.group({
    email: ["", Validators.email],
    password: ["", Validators.required],
  });

  inputType = "password";
  visible = false;

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private cd: ChangeDetectorRef,
    private snackbar: SnackbarService,
    private as: AuthService,
    private us: UserService,
  ) {}

  signIn(user: User): void {
    this.us.setUser$(user);
    this.us.setUser(user);
    this.router.navigate(['dashboard']);
  }

  signInWithEmailAndPassword() {
    if (this.form.valid) {
      const email: string = this.form.controls.email.value || '';
      const password: string = this.form.controls.password.value || '';
      this.as.signInUserWithEmailAndPassword(email, password).then((response) => {
        this.signIn(response.user)
      }).catch((error) => {
        this.snackbar.error(error);
      })
    } else {
      this.snackbar.error('Please provide email and password');
    }
  }

  signInWithGoogle(): void {
    this.as
      .signInWithGoogle()
      .then((response: UserCredential) => {
        this.signIn(response.user);
      })
      .catch(() => {});
  }

  signInWithFacebook(): void {
    this.as
      .signInWithFacebook()
      .then((response: UserCredential) => {
        this.signIn(response.user);
      })
      .catch(() => {});
  }

  signInWithTwitter(): void {
    this.as
      .signInWithTwitter()
      .then((response: UserCredential) => {
        this.signIn(response.user);
      })
      .catch(() => {});
  }

  toggleVisibility() {
    if (this.visible) {
      this.inputType = "password";
      this.visible = false;
      this.cd.markForCheck();
    } else {
      this.inputType = "text";
      this.visible = true;
      this.cd.markForCheck();
    }
  }
}
